import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './helpers/auth.guard';
import { JobComponent } from './pages/job/job.component';
import { NewPositionComponent } from './pages/addNewPosition/addNewPosition.component';
import { ScheduleInterviewComponent } from './pages/scheduleInterview/scheduleInterview.component';
import { ViewScheduledInterviewComponent } from './pages/viewScheduledInterviews/viewInterview.component';
import { CandidateFeedbackComponent } from './pages/candidate-feedback/candidate-feedback.component';
import { CandidateEvaluationComponent } from './pages/candidate-evaluation/candidate-evaluation.component';
import { ViewAllInterviewsListComponent } from './pages/view-all-interviews-list/view-all-interviews-list.component';
import { InterviewerDashboardComponent } from './pages/interviewerDashboard/interviewer-dashboard.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AssignUserRoleComponent } from './assign-user-role/assign-user-role.component';
import { AgencyAddEditComponent } from './agency-add-edit/agency-add-edit.component';
import { TechnologyAddEditComponent } from './technology-add-edit/technology-add-edit.component';
import { TemplateAddEditComponent } from './template-add-edit/template-add-edit.component';
import { AddTemplateComponent } from './template-add-edit/add-template/add-template.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent , canActivate: [AuthGuard]},
  { path: 'job', component: JobComponent , canActivate: [AuthGuard], data: {roles: ['HRAdmin', 'SuperAdmin', 'Recruiter']}},
  { path: 'interview-schedule-list', component: JobComponent , canActivate: [AuthGuard]},
  { path: 'view-scheduled-interview-list/:id', component: ViewScheduledInterviewComponent , canActivate: [AuthGuard]},
  { path: 'view-all-scheduled-interview-list', component: ViewAllInterviewsListComponent , canActivate: [AuthGuard]},
  { path: 'feedback/:id', component: CandidateFeedbackComponent, canActivate: [AuthGuard]},
  { path: 'candidate-evaluation', component: CandidateEvaluationComponent, canActivate: [AuthGuard]},
  { path: 'interview-dashboard', component: InterviewerDashboardComponent, canActivate: [AuthGuard]},
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard]},
  { path: 'login', component: LoginComponent },
  { path: '', component: LoginComponent },
  { path: 'manage-position', component: NewPositionComponent, canActivate: [AuthGuard],data: {roles: ['HRAdmin','SuperAdmin']}},
  { path: 'schedule-interview/:id/:name', component: ScheduleInterviewComponent, canActivate: [AuthGuard]},
  { path: 'manage-position/:id/:edit', component: NewPositionComponent,canActivate: [AuthGuard],data: {roles: ['HRAdmin','SuperAdmin']} },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'assign-user-role', component: AssignUserRoleComponent, canActivate: [AuthGuard], data: { roles: ['SuperAdmin'] } },
  { path: 'technology-add-edit', component: TechnologyAddEditComponent, canActivate: [AuthGuard], data: { roles: ['SuperAdmin'] } },
  { path: 'agency-add-edit', component: AgencyAddEditComponent, canActivate: [AuthGuard], data: { roles: ['SuperAdmin'] } },
  { path: 'template-add-edit', component: TemplateAddEditComponent, canActivate: [AuthGuard], data: { roles: ['SuperAdmin'] } },
  { path: '**', component: PageNotFoundComponent }  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true ,onSameUrlNavigation:`reload`})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
